import * as React from 'react';
import { connect } from 'react-redux';
import { push } from "connected-react-router";
import { Login, Logout } from '../redux/actions/AuthActions';
import { Button } from "reactstrap";
import { IStore } from '../redux/constants';
import { withTranslation } from 'react-i18next';

const mapStateToProps = (state: IStore) => ({
    userData: state.auth.UserData,
    lang: state.language.value,
    history: state.history,
    URL: state.auth.UserData.yoonitGetURL,
    theme: state.theme
});
declare var require: any

const logo = require("../Assets/imgs/yoonitlogo.png") as string;
const WhiteLogo = require("../Assets/imgs/whiteyoonit.png") as string;
const noAccess = require("../Assets/imgs/noAccess.png") as string;
const noAccessWhite = require("../Assets/imgs/noAccessWhite.png") as string;
const dispatchProps = { push, Login, Logout }
export interface NotAuthPageProps {
    lang: string;
    userData: any;
    push: any;
    URL: string;
    theme: any;
    t: any;
}

export interface NotAuthPageState {
}

class NotAuth extends React.Component<NotAuthPageProps, NotAuthPageState> {
    state = {

    }
    navigate = () => {
        this.props.push('/login');
    }
    render() {
        return (<React.Fragment>
            <div className="mt-160 height100Vh">
                <div className="m-sm-4">
                    <div className="text-center mt-120"  >
                        <img alt="" src={this.props.theme.currentTheme === "addons-Light" ? logo : WhiteLogo} className="logoIcon" />
                        <h5 className="NotAuth mt-6 ">  <img alt="" src={this.props.theme.currentTheme === "addons-Light" ? noAccess : noAccessWhite} className="notAuthIcon mr-2 d-inline-flex" />
                            <p className="PagenotFoundText d-inline-flex" > {this.props.t("UserNotAuthorizedToAccessThisPage")}</p>
                        </h5>
                        <Button onClick={this.navigate} to="/" className="BackBtn2 mt-4"> {this.props.t("Login")} </Button>
                    </div>

                </div>
            </div>
        </React.Fragment>);
    }
}
export default withTranslation()(connect(mapStateToProps, dispatchProps)(NotAuth));
